import type { Board } from 'chessboard/model/board/types';
import { Core } from 'chessboard/core/config/types';
import { isNotOneOf } from 'src/utils/app/model/is-not-one-of';
import { MoveHints } from 'chessboard/plugins/move-hints/config/types';
import type { Plugins } from 'chessboard/core/plugins/config/types';
import { Timer } from 'plugins/clocks/timer/config/types';
import { updateHints } from 'chessboard/model/move-hints/update';
import { is } from 'src/utils/app/model/is';

/**
 * Manages the display of move hints.
 */
export function createMoveHintsPlugin(): Plugins.Model {
  let moveHints: Board.SanSquare[] = [];

  return {
    match: [
      {
        condition: isNotOneOf([Core.UserEvents.Pointermove, Timer.Events.Tick]),
        handler: updateMoveHints,
      },
      { condition: is(Core.InstanceEvents.RendererSet), handler: resetMoveHints },
    ],
    name: MoveHints.Plugin.Name,
  };

  /**
   * Reset all move hints. Called after changing the renderer, as we
   * need to add the previously existing hints back to the board.
   */
  function resetMoveHints(event: Core.Event, ctx: Core.Context) {
    moveHints = [];

    updateMoveHints(event, ctx);
  }

  /**
   * Update the rendered move hints.
   */
  function updateMoveHints(_event: Core.Event, context: Core.Context) {
    const { renderer } = context;

    if (!renderer) {
      return;
    }

    moveHints = updateHints({
      addMoveHints: renderer.addMoveHints,
      addCaptureHints: renderer.addCaptureHints,
      context,
      currentHints: moveHints,
      getNextHints: (legalMoves) => legalMoves.filter((square) => !moveHints.includes(square)),
      removeHints: renderer.removeHints,
    });
  }
}
